import { SYSTEM_TYPE } from './systemConfig'

export const LIVE_MALL_CLUB_ROUTE_QUERY_STRING = {
  PROFILE_MORE_MENU_OPEN: {
    more: 'true',
  },
}

const ROUTE_QUERY_STRING_MAP = {
  [SYSTEM_TYPE.LIVE_MALL_CLUB]: LIVE_MALL_CLUB_ROUTE_QUERY_STRING,
}

export const ROUTE_QUERY_STRING = ROUTE_QUERY_STRING_MAP[`${process.env.SYSTEM_TYPE}`]
export type RouteQueryStringKeyType = keyof typeof ROUTE_QUERY_STRING
